import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button } from '@foodsby/nutrient-v3'
import { useSubscriptionDetails } from '../../hooks/subscriptions'
import { addSubscriptionPromoPreference } from '../../redux/modules/subscriptions'
import posed from 'react-pose'
import cn from 'classnames'
import { pushAnalyticsEvent } from '../../util/gtmUtils'

const DriveAnimation = posed.img({
  enter: { x: 0, opacity: 0 },
  atRest: { x: 30, opacity: 1 },
  exit: {
    x: props => {
      const width = props?.parentRef?.current?.offsetWidth || 600
      return width - 30
    },
    opacity: 0,
    transition: {
      x: { ease: 'anticipate', duration: 600 },
      opacity: { ease: 'easeOut', delay: 400, duration: 200 },
    },
  },
})

export const SubscriptionPromoButtonRotatingTitle = ({
  rotateTitle = true,
}) => <SubscriptionPromotional rotateTitle={rotateTitle} />

export const SubscriptionPromotional = ({ rotateTitle = false }) => {
  const dispatch = useDispatch()
  const { subscriptionDetails, subscriptionEligible } = useSubscriptionDetails()
  const preferences = useSelector(
    state => state.subscriptions.subscriptionPromoPreference,
  )
  const subscriptionFee = useSelector(
    state => state?.location?.location?.subscriptionFee,
  )
  const [optedIn, setOptedIn] = useState(null)
  const [runAnimation, setRunAnimation] = useState('atRest')
  const [hover, setHover] = useState(false)
  const [title, setTitle] = useState()
  const containerRef = useRef()

  const optInSubscriptionPromo = () => {
    pushAnalyticsEvent('Subscriptions', 'Promo Card - Opted in')
    setOptedIn(true)
    dispatch(addSubscriptionPromoPreference({ optIntoPromo: true }))
  }

  const optOutSubscriptionPromo = () => {
    pushAnalyticsEvent('Subscriptions', 'Promo Card - Opted out')
    setOptedIn(false)
    dispatch(addSubscriptionPromoPreference({ optIntoPromo: false }))
  }

  const isEligible =
    (subscriptionDetails === null ||
      subscriptionDetails?.status === 'UNSUBSCRIBED') && // Haven't had a prev subscription, or is unsubscribed
    subscriptionEligible &&
    !preferences?.hidden // Hasn't chose to hide the promo

  const hasHadPrevSub = subscriptionDetails !== null

  const titles = [
    `It's kind of a big dill! We’re offering Unlimited Delivery on every order.`,
    `Go Bananas! We’re offering Unlimited Delivery on every order.`,
    `You feta believe it! We’re offering Unlimited Delivery on every order.`,
  ]

  useEffect(() => {
    if (optedIn) {
      setRunAnimation('exit')
      setTimeout(() => {
        setRunAnimation('enter')
      }, 600)
      setTimeout(() => {
        setRunAnimation('atRest')
      }, 800)
    }
  }, [optedIn])

  useEffect(() => {
    pushAnalyticsEvent('Subscriptions', 'Promo Card - View')
    if (rotateTitle) {
      setTitle(titles[Math.floor(Math.random() * titles.length)])
    } else {
      setTitle('Say goodbye to delivery fees with Unlimited Delivery')
    }
  }, []) //eslint-disable-line

  return isEligible ? (
    <div className={'WebConV3 SubscriptionPromotional'} ref={containerRef}>
      <div>
        <DriveAnimation
          alt=""
          className="-carModel"
          parentRef={containerRef}
          pose={runAnimation}
          src="https://images.foodsby.com/conweb/subscription-car-new-red.png"
          width="60px"
        />
      </div>
      <h4 className="-title">{title}</h4>
      <p className="-body">
        {hasHadPrevSub
          ? `Get free delivery on all orders when you subscribe for $${subscriptionFee}/month. Cancel anytime.`
          : `Get free delivery on all orders when you subscribe for $${subscriptionFee}/month.
        Enjoy your first month free! Cancel anytime.`}
      </p>
      {!optedIn && !preferences?.optIntoPromo ? (
        <Button id="SubscriptionPromoButton" onClick={optInSubscriptionPromo}>
          {subscriptionDetails ? 'SUBSCRIBE' : 'TRY FOR FREE'}
        </Button>
      ) : (
        <>
          <Button
            className={cn({
              destructive: hover,
              secondary: !hover,
            })}
            id="SubscriptionPromoButton"
            onClick={optOutSubscriptionPromo}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          >
            {hover ? (
              <>
                <i className="icon-times-circle" /> UNSUBSCRIBE
              </>
            ) : (
              <>
                <i className="icon-check-circle" /> SUBSCRIBED
              </>
            )}
          </Button>
          <p className="-body --optIn">
            Your trial will begin when you place your order! Manage at checkout.
          </p>
        </>
      )}
    </div>
  ) : null
}

export default SubscriptionPromotional
